import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createBlock as _createBlock } from "vue"

import { nextTick, ref, watch } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  modelValue: {
    type: [String, Number],
    default: ''
  },
  inputType: {
    type: String,
    default: ''
  },
  maxlength: {
    type: Number,
    default: 6
  },
  maximum: {
    type: Number,
    default: 0
  }
},
  emits: ['on-value-change', 'update:modelValue'],
  setup(__props, { emit }) {

const props = __props;





const showInput = ref(true)
const onEditCell = () => {
  showInput.value = false
  nextTick(() => {
    const input: any = document.querySelector('.EL__focus .el-input__inner')
    input.focus()
  })
}

const oldIndex = ref()
// 修改排序输入框获取焦点事件
const onSIndexFocus = (e) => {
  // 因为编辑时会改变之前的值，所以要记住之前的值
  oldIndex.value = Number(e.target.value)
}


// 修改排序输入框丢失焦点事件
const onSIndexBlur = async (e) => {
  if (e.target.value === '' || Number(e.target.value) === 0) {
    newModelValue.value = oldIndex.value
    emit('on-value-change', Number(newModelValue.value), Number(oldIndex.value), done)
  } else {
    emit('on-value-change', Number(newModelValue.value), Number(oldIndex.value), done)
  }
}

const onInput = (e) => {
  newModelValue.value = e.replace(/[^\d]/g, '')
  if (props.maximum && e > props.maximum) {
    newModelValue.value = props.maximum
  }
}

const done = () => {
  showInput.value = true
}

const newModelValue = ref()

watch(() => props.modelValue, (val) => {
  newModelValue.value = val
}, {
  immediate: true,
  deep: true
})


return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!

  return (showInput.value)
    ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        style: {"display":"inline-block","width":"100%"},
        class: "pointer",
        onDblclick: onEditCell
      }, _toDisplayString(newModelValue.value), 33))
    : (_openBlock(), _createBlock(_component_el_input, _mergeProps({ key: 1 }, _ctx.$attrs, {
        maxlength: __props.maxlength,
        type: __props.inputType,
        class: "EL__focus",
        modelValue: newModelValue.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((newModelValue).value = $event)),
        onFocus: onSIndexFocus,
        onBlur: onSIndexBlur,
        onInput: onInput
      }), null, 16, ["maxlength", "type", "modelValue"]))
}
}

})